import { render, staticRenderFns } from "./AdvisorDashboard.vue?vue&type=template&id=5afa37df&scoped=true"
import script from "./AdvisorDashboard.vue?vue&type=script&lang=js"
export * from "./AdvisorDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDashboard.vue?vue&type=style&index=0&id=5afa37df&prod&scoped=true&lang=css"
import style1 from "./AdvisorDashboard.vue?vue&type=style&index=1&id=5afa37df&prod&lang=css"
import style2 from "./AdvisorDashboard.vue?vue&type=style&index=2&id=5afa37df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa37df",
  null
  
)

export default component.exports